import React, { FC } from 'react';

import { CreateSpaceButton } from '@confluence/create-space/entry-points/createSpace';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

export const HTV2CreateSpaceCTA: FC = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClick = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'homeOnboardingTakeoverV2ActionCta',
				attributes: {
					onboardingAction: 'createASpace',
				},
			},
		}).fire();
	};

	return (
		<CreateSpaceButton
			onClick={handleClick}
			source="home-onboarding-takeover-v2"
			appearance="default"
		/>
	);
};
